var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPremiumFeatureCrown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 13,
    viewBox: "0 0 19 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5611 7.28745C4.43012 7.28745 2.15852 5.01244 1.26338 4.06613C1.56544 3.92445 1.77647 3.61909 1.77647 3.26422C1.77647 2.77457 1.37924 2.37843 0.888231 2.37843C0.397221 2.37706 0 2.77457 0 3.26285C0 3.75252 0.397221 4.14864 0.888231 4.14864C0.94202 4.14864 0.994432 4.14315 1.04546 4.13352L3.76257 12.3299H9.2547V0.886055C9.2547 0.886055 8.15544 7.28745 5.5611 7.28745Z",
    fill: "#DBA249"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.01203 5.89657C7.01203 5.89657 6.11415 4.61739 5.61625 3.62982C5.87555 3.54729 6.0645 3.30521 6.0645 3.0191C6.0645 2.66562 5.77624 2.37814 5.42177 2.37814C5.06731 2.37814 4.77905 2.66562 4.77905 3.0191C4.77905 3.36572 5.05627 3.6477 5.40107 3.65869C5.31419 4.36019 5.09627 5.81679 4.69629 6.52653C4.69766 6.52653 5.85485 7.83184 7.01203 5.89657Z",
    fill: "#DBA249"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8133 6.52653C13.4134 5.81679 13.1955 4.36019 13.1086 3.65869C13.4547 3.6477 13.7307 3.36572 13.7307 3.0191C13.7307 2.66562 13.4438 2.37814 13.0879 2.37814C12.7334 2.37814 12.4452 2.66562 12.4452 3.0191C12.4452 3.30521 12.6341 3.54866 12.8934 3.62982C12.3955 4.61877 11.499 5.89657 11.499 5.89657C12.6562 7.83184 13.8133 6.52653 13.8133 6.52653Z",
    fill: "#E4BC67"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6228 2.37706C17.1331 2.37706 16.7345 2.77318 16.7345 3.26285C16.7345 3.61772 16.9441 3.92307 17.2476 4.06474C16.3524 5.01106 14.0822 7.28608 12.9499 7.28608C10.3555 7.28745 9.25488 0.886055 9.25488 0.886055V12.3299H14.747L17.4641 4.13352C17.5152 4.14315 17.5675 4.14864 17.6213 4.14864C18.1124 4.14864 18.5096 3.75252 18.5096 3.26285C18.5109 2.77457 18.1137 2.37706 17.6228 2.37706Z",
    fill: "#E4BC67"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1427 0.885797C10.1427 1.37546 9.74545 1.7716 9.25444 1.7716C8.7648 1.7716 8.36621 1.37546 8.36621 0.885797C8.36621 0.396133 8.7648 0 9.25444 0C9.74545 0 10.1427 0.396133 10.1427 0.885797Z",
    fill: "#DBA249"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPremiumFeatureCrown);
export default __webpack_public_path__ + "static/media/premium-feature-crown.67b27ba3b53c861aecf3e3bcefcb68a5.svg";
export { ForwardRef as ReactComponent };